export default __webpack_public_path__ + "static/media/NotEnough.de4a338e.svg";